// Cycle through the top anchor elements and add attributes to corresponding anchor elements in the share-footer
document.querySelectorAll('.top-btn:not(.btn-print)').forEach(function(topButton) {
  var buttonClass = Array.from(topButton.classList).find(function(cls) {
    return cls.startsWith('btn-') && cls !== 'btn-share' && cls !== 'top-btn' && cls !== 'mb10' && cls !== 'mr5';
  });

  if (buttonClass) {
    var correspondingButton = document.querySelector('.share-footer .' + buttonClass);
    if (correspondingButton) {
      topButton.setAttribute('href', correspondingButton.getAttribute('href'));
      topButton.setAttribute('target', correspondingButton.getAttribute('target'));
    }
  }
});

//Open social media links in small window
document.querySelectorAll('.btn-share').forEach(function(button) {
  button.addEventListener('click', function(event) {
    event.preventDefault();
    window.open(this.href, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600");
  });
});